import { useAppSelector } from 'soapbox/hooks';

/** Get compose for given key with fallback to 'default' */
export const useCompose = composeId => {
  return useAppSelector(state => state.compose.get(composeId, state.compose.get('default')));
};